module.exports = __webpack_public_path__ + "static/media/new-channel-min.2d2246ae.gif";